module.exports = __webpack_public_path__ + "static/media/Inter-Light.424b3e63.eot";